import React from 'react';
import {NextPage} from 'next';
import {ContactUsSection, FindUsSection, HeaderSectionContact,} from 'containers/common/sections/contact-us';
import {Page} from 'containers/common/sections/layout';
import { createGetServerSideProps, StaticPageProps } from "evcharging/app";
import {I18nPage} from "i18n/types/pages.enum";

const ContactUsPage: NextPage<StaticPageProps> = ({ page }) => {
  return (
    <Page title={page.meta_title} description={page.meta_description} locales={page.locales} showTransparentBg>
      <HeaderSectionContact />
      <ContactUsSection />
      <FindUsSection />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, undefined, [I18nPage.ContactUs]);

export default ContactUsPage;
